import { EventCenterInfoCard } from "./EventCenterInfoCard";

export default EventCenterInfoCard;
